export default __webpack_public_path__ + "static/bulb-01-7c54a31aff7fb82910ddb81cb54b5962.svg";